module.exports = __webpack_public_path__ + "static/media/doclad12.55674c51.pdf";